import React from 'react';
import { ProductPage } from './pages/ProductPage';
export function App() {
  return <div className="min-h-screen w-full bg-white" data-id="element-0">
      <ProductPage data-id="element-1" />
    </div>;
}